import { render, staticRenderFns } from "./CardContractDocument.vue?vue&type=template&id=5af64c63&scoped=true"
import script from "./CardContractDocument.vue?vue&type=script&lang=js"
export * from "./CardContractDocument.vue?vue&type=script&lang=js"
import style0 from "./CardContractDocument.vue?vue&type=style&index=0&id=5af64c63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af64c63",
  null
  
)

export default component.exports